import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { SourceType } from '@returnmates/client-core/src/constants/sourceType'
import { Package } from '@returnmates/client-core/src/graphql/generated/api'
import clsx from 'clsx'
import moment from 'moment-timezone'
import { memo } from 'react'

import useStyles from '../styles'

interface Props {
  currentPackage: Package | null
}

const PackageSource = ({ currentPackage }: Props) => {
  const classes = useStyles()

  return (
    <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow className={classes.headerRow}>
          <TableCell className={classes.headerCell}>Date</TableCell>
          <TableCell className={classes.headerCell}>Source</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow className={classes.tableRow}>
          <TableCell className={clsx(classes.bodyCell, classes.noWrapText)}>
            {currentPackage?.createdAt
              ? moment
                  .unix(currentPackage.createdAt)
                  .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                  .format('M/D/YY h:mm A z')
              : null}
          </TableCell>
          <TableCell className={classes.bodyCell}>
            {`Created via ${currentPackage?.source} ${
              currentPackage?.source === SourceType.WILSON
                ? currentPackage?.createdBy
                  ? `- ${currentPackage?.createdBy?.email}`
                  : ''
                : ''
            }`}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  )
}
export default memo(PackageSource)
